import React from "react";
import { BasePageModal } from "@/shared/components/modal/page-modal/base-page-modal";
import { BaseRoundButton } from "@/shared/components/button/base-round-button";
import { useAccountGroupsContext } from "@/features/accounts/account-group/contexts/account-groups-context";
import { useModalContext } from "@/shared/components/modal/contexts/modal-context";
import { SimpleForm } from "@/shared/components/text-box/simple-form";

interface Props {
  onTapCloseModal: () => void;
}

export const SelectMoveAccountGroupModal = ({ onTapCloseModal }: Props) => {
  const {
    targetAccountGroup,
    setSelectedAccount,
  } = useAccountGroupsContext();
  const {
    setOpenMyDataModal,
  } = useModalContext();

  const getClassName = (passbookType: string) => {
    if (passbookType === "01" || passbookType==="09") {
      return "btn-bank";
    } else if (passbookType === "19659" || passbookType==="19660" || passbookType==="03") {
      return "btn-card";
    } else if (passbookType === "10") {
      return "btn-emoney";
    } else if (passbookType === "20") {
      return "btn-app";
    } else if (passbookType === "201" || passbookType==="202") {
      return "btn-excel";
    } else if (passbookType === "101") {
      return "btn-ocr";
    }
    return "";
  }

  const message = targetAccountGroup.accountsList.length > 0
    ? "明細帳を他のグループへ移動できます"
    : "このグループには明細帳が設定されていません。";

  return (
    <BasePageModal
      handleClose={onTapCloseModal}
      title="グループの移動"
      className="md-group-edit group-move-modal"
    >
      <h2>
        {message}
      </h2>
      <dl>
        <SimpleForm
          id="accountGroupName"
          value={targetAccountGroup.accountGroupsName}
          isReadOnly={true}
          title="グループ名"
          onChange={() => {}}
          labelEnable={true}
          descriptionType={true}
        />
      </dl>
      {targetAccountGroup.accountsList.length > 0 ? (
        <ol className="sortable-list" id="sortableList">
          {targetAccountGroup.accountsList.map((item, index) => (
            <li key={index} className="sortable-item">
              <strong className={getClassName(item.passbookType)}>
                {item.passbookName}
              </strong>
              <BaseRoundButton
                buttonText="移動"
                onClick={() => {
                  // TODO: ↓改良
                  setSelectedAccount({
                    industryCode: "",
                    companyCode: "",
                    companyName: "",
                    serviceCode: "",
                    serviceName: "",
                    branchCode: "",
                    branchName: "",
                    passbookName: item.passbookName,
                    balance: "",
                    authorizationStatus: 1,
                    selectedStatus: 1,
                    accountGroupId: targetAccountGroup.accountGroupId,
                    mlinkAccountId: item.mlinkAccountId,
                    mlinkId: item.mlinkId,
                    passbookType: item.passbookType,
                    registeredDate: "",
                    scrapeType: 0,
                    ocrProcessId: "",
                    ocrProcessStatus: 0,
                    otpYn: "0",
                    isUnderMaintenance: false,
                  });
                  setOpenMyDataModal("MoveGroup");
                }}
              />
            </li>
          ))}
        </ol>
      ) : (
        <></>
      )}
    </BasePageModal>
  );
};
